export default {
  collapse: '收起菜單',
  expand: '展開菜單',
};
